export const getBowserName = () => {
  const agent = window.navigator.userAgent.toLowerCase();
  switch (true) {
    case agent.indexOf("edge") > -1:
      return "MS Edge";
    case agent.indexOf("edg/") > -1:
      return "Edge ( chromium based)";
    case agent.indexOf("opr") > -1 && !!window.opr:
      return "Opera";
    case agent.indexOf("chrome") > -1 && !!window.chrome:
      return "Chrome";
    case agent.indexOf("trident") > -1:
      return "MS IE";
    case agent.indexOf("firefox") > -1:
      return "Mozilla Firefox";
    case agent.indexOf("safari") > -1:
      return "Safari";
    default:
      return "other";
  }
};

export const getOsOfUser = () => {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const osList = [
    { name: "Windows 3.11", regex: /Win16/ },
    { name: "Windows 95", regex: /(Windows 95)|(Win95)|(Windows_95)/ },
    // Add more OS and corresponding regex patterns as needed
    { name: "Windows 10", regex: /(Windows NT 10.0)/ },
    { name: "Windows 8.1", regex: /(Windows NT 6.3)/ },
    { name: "Windows 8", regex: /(Windows NT 6.2)/ },
    { name: "Windows 7", regex: /(Windows NT 6.1)/ },
    { name: "Windows Vista", regex: /(Windows NT 6.0)/ },
    { name: "Windows XP", regex: /(Windows NT 5.1)|(Windows XP)/ },
    { name: "macOS", regex: /(Mac_PowerPC)|(Macintosh)|(Mac OS X)/ },
    { name: "Linux", regex: /(Linux)|(X11)/ },
    { name: "iOS", regex: /(iPhone)|(iPad)|(iPod)/ },
    { name: "Android", regex: /Android/ },
  ];

  for (const os of osList) {
    if (os.regex.test(userAgent) || os.regex.test(platform)) {
      return os.name;
    }
  }

  return "Unknown"; // If the OS cannot be identifi
};
